export const OUTCOME_LABELS = {
    approved: 'Approved',
    approved_with_changes: 'Approved with changes',
    not_approved: 'Not approved'
};
export const OUTCOME_OPTIONS = [
    'approved',
    'approved_with_changes',
    'not_approved'
];
export const SEVERITIES = [
    'note',
    'minor',
    'major',
    'critical'
];
export const NAME_CHIPS = [
    'Pink',
    'Red',
    'Gold'
];
export function outcomeLabel(outcome) {
    return OUTCOME_LABELS[outcome] ?? outcome;
}
/**
 * The words a section's review state is shown in. An approval is only ever shown as
 * current while the section is unchanged since it: a changed section reads "Not reviewed".
 */ export function describeReviewState(s) {
    if (!s) return {
        text: 'Not reviewed',
        tone: 'neutral'
    };
    const last = s.lastReview;
    const at = last ? `${last.reviewName} (v${last.reviewedVersion})` : '';
    if (s.state === 'in_review') {
        return {
            text: `In review: ${s.openReviewName}`,
            tone: 'info'
        };
    }
    if (s.changedSinceReview || s.state === 'not_reviewed') {
        return {
            text: s.changedSinceReview && last ? `Not reviewed — changed since ${at}` : 'Not reviewed',
            tone: 'neutral'
        };
    }
    if (!last) return {
        text: 'Not reviewed',
        tone: 'neutral'
    };
    if (s.state === 'approved') return {
        text: `Approved in ${at}`,
        tone: 'success'
    };
    if (s.state === 'approved_with_changes') {
        return {
            text: `Approved with changes in ${at}`,
            tone: 'warning'
        };
    }
    if (s.state === 'not_approved') return {
        text: `Not approved in ${at}`,
        tone: 'danger'
    };
    return {
        text: 'Not reviewed',
        tone: 'neutral'
    };
}
